module.exports = __webpack_public_path__ + "img/add_information.1f183e53.svg";